import { render } from "./SuscripcionForm.vue?vue&type=template&id=57053d0e&scoped=true"
import script from "./SuscripcionForm.vue?vue&type=script&lang=js"
export * from "./SuscripcionForm.vue?vue&type=script&lang=js"

import "@/assets/css/tabs.css?vue&type=style&index=0&id=57053d0e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57053d0e"]])

export default __exports__